"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputCheckbox = void 0;
const react_1 = __importStar(require("react"));
const vobaza_ui_icon_1 = require("@nebo-team-dev/vobaza.ui.icon");
const input_checkbox_styled_1 = require("./input-checkbox.styled");
function InputCheckbox(_a) {
    var { label, variation = 'primary', onChange, initialValue = false, isError = false, disabled = false } = _a, restProps = __rest(_a, ["label", "variation", "onChange", "initialValue", "isError", "disabled"]);
    const [isActive, setIsActive] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        setIsActive(initialValue || false);
    }, [initialValue]);
    const handleChangeCheckbox = (value) => {
        onChange && onChange(value);
        setIsActive(value);
    };
    return (react_1.default.createElement(input_checkbox_styled_1.StyledCheckboxWrap, Object.assign({ disabled: disabled, onClick: () => handleChangeCheckbox(!isActive) }, restProps),
        react_1.default.createElement(input_checkbox_styled_1.StyledCheckboxField, { className: disabled && 'disabled', isActive: isActive, isError: isError, "data-variation": variation, disabled: disabled }, isActive && (react_1.default.createElement(vobaza_ui_icon_1.Icon, { style: { color: disabled ? '#909090' : '#fff' }, name: 'Checkmark' }))),
        react_1.default.createElement(input_checkbox_styled_1.StyledCheckboxLabel, { disabled: disabled, "data-variation": variation }, label)));
}
exports.InputCheckbox = InputCheckbox;
//# sourceMappingURL=input-checkbox.js.map